import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { getHomePathForRole } from "../utils/rolePaths";
import Dashboard from "../scenes/dashboard";

/** `/`: analytics dashboard for admins only; other roles go to their home route. */
export default function DashboardEntry() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
        <CircularProgress />
      </Box>
    );
  }
  const role = typeof user?.role === "string" ? user.role.trim().toLowerCase() : user?.role;
  if (role === "admin") return <Dashboard />;
  if (role === "manager" || role === "designer") {
    return <Navigate to={getHomePathForRole(role)} replace />;
  }
  return <Navigate to="/login" replace />;
}
